require('./fontawesome');
require('./bootstrap');

// 各ページ毎のJS
require('./pages/menu/index');
require('./pages/account/index');
require('./pages/contract/index');
require('./pages/welcome/index');
require('./pages/yahoo_auth_call_back/index');
require('./pages/setup/index');
require('./pages/build_store/index');
require('./pages/chrome_extensions/index');
require('./pages/item/index');
require('./pages/guide/index');
require('./pages/canva_templates/index');
require('./pages/custom_page/index');
require('./pages/imagestock/index');
